import {
  useModalStore,
  processSocket,
  useProcessCreationLoadingStore,
  useProcessSocketStore,
} from "@/entities"
import type { ContentFromTextDto } from "@/shared/api/generated"
import { contentControllerCreateContentFromTextHttp } from "@/shared/api/generated"
import { Modal } from "@/shared/types"
import { useForm } from "react-hook-form"

type FormData = ContentFromTextDto

export function useCreateNoteText() {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>({
    defaultValues: {
      text: "",
    },
  })

  const closeModal = useModalStore(s => s.closeModal)

  return {
    control,
    handleSubmit: handleSubmit(async values => {
      closeModal(Modal.CREATE_CONTENT_WITH_TEXT)
      useProcessCreationLoadingStore.getState().startAppLoading()

      try {
        await useProcessSocketStore.getState().connectToProcessSocket()
        await contentControllerCreateContentFromTextHttp({
          text: values.text,
          socketClientId: processSocket.id,
        })
      } catch {
        useProcessCreationLoadingStore.getState().closeAppLoading()
      }
    }),
    errors,
  }
}
